var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcademyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_36146",
    "data-name": "Gruppe 36146",
    transform: "translate(-702.83 -3690.77)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_529",
    "data-name": "Ellipse 529",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(702.83 3690.77)",
    fill: "#e5f5f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-graduation-cap",
    "data-name": "Icon awesome-graduation-cap",
    d: "M25.283,8.124,13.951,4.642a3.245,3.245,0,0,0-1.9,0L.718,8.124a.956.956,0,0,0,0,1.852l1.976.607a3.2,3.2,0,0,0-.726,1.905,1.254,1.254,0,0,0-.1,2.154L.826,19.309a.65.65,0,0,0,.634.791H3.74a.65.65,0,0,0,.635-.791L3.337,14.642a1.25,1.25,0,0,0-.073-2.134A1.916,1.916,0,0,1,4.1,11.017l7.945,2.441a3.249,3.249,0,0,0,1.9,0L25.283,9.976a.957.957,0,0,0,0-1.853ZM14.332,14.7a4.548,4.548,0,0,1-2.665,0l-5.891-1.81L5.2,17.5c0,1.436,3.492,2.6,7.8,2.6s7.8-1.164,7.8-2.6l-.576-4.61L14.332,14.7Z",
    transform: "translate(711.83 3700.069)",
    fill: "#1c9d87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademyIcon);
export default __webpack_public_path__ + "static/media/AcademyIcon.1d7dfb8071e260d2e5e8ef835e997f5d.svg";
export { ForwardRef as ReactComponent };